import {getRecordId} from 'src/modules/tarea/tareaParcialHelpers';
import {
  resolvePlastyvergArticuloTitulo,
  resolvePlastyvergArticuloVariant,
} from 'src/modules/tarea/plastyvergArticuloToleranceBounds';

export const LIST_PDF_FILTER_SHORTCUT_MAX_COUNT = 30;

export const getTaskTituloTarea = (task: any) => String(resolvePlastyvergArticuloTitulo(task) || '').trim();

export const getModeloTareaIdFromFilter = (filter: any) => {
  if (!filter?.modeloTarea) return null;
  return getRecordId(filter.modeloTarea) || filter.modeloTarea || null;
};

export const canUseListPdfFilterShortcut = (count: number, filter: any) =>
  Number(count) > 0 && Number(count) < LIST_PDF_FILTER_SHORTCUT_MAX_COUNT + 1 && Boolean(getModeloTareaIdFromFilter(filter));

export const findTaskInRows = (rows: any[] = [], key: string) => {
  const walk = (items: any[]): any => {
    for (const row of items || []) {
      if (row?.id === key) return row;
      if (row?.children?.length) {
        const found = walk(row.children);
        if (found) return found;
      }
    }
    return null;
  };
  return walk(rows);
};

export const selectedTasksShareTituloTarea = (selectedKeys: string[], rows: any[]) => {
  if (!selectedKeys?.length) return false;
  let titulo: string | null = null;
  for (const key of selectedKeys) {
    const task = findTaskInRows(rows, key);
    const taskTitulo = getTaskTituloTarea(task);
    if (!taskTitulo) return false;
    if (titulo === null) titulo = taskTitulo;
    else if (titulo !== taskTitulo) return false;
  }
  return true;
};

export const tasksMixId25AndId26 = (tasks: any[] = []) => {
  let hasId25 = false;
  let hasId26 = false;
  for (const task of tasks) {
    const variant = resolvePlastyvergArticuloVariant(resolvePlastyvergArticuloTitulo(task));
    if (variant === 'ID-25') hasId25 = true;
    if (variant === 'ID-26') hasId26 = true;
    if (hasId25 && hasId26) return true;
  }
  return false;
};

export const selectedTasksMixId25AndId26 = (selectedKeys: string[], rows: any[]) => {
  if (!selectedKeys?.length) return false;
  const tasks = selectedKeys.map((key) => findTaskInRows(rows, key)).filter(Boolean);
  return tasksMixId25AndId26(tasks);
};

export const collectTaskIdsFromRows = (rows: any[] = []) => {
  const ids: string[] = [];
  const walk = (items: any[]) => {
    for (const row of items || []) {
      if (row?.id) ids.push(row.id);
      if (row?.children?.length) walk(row.children);
    }
  };
  walk(rows);
  return ids;
};

export const wouldSelectingKeyMixId25AndId26 = (selectedKeys: string[], rows: any[], nextKey: string) => {
  if (!nextKey || selectedKeys.includes(nextKey)) return false;
  return selectedTasksMixId25AndId26([...selectedKeys, nextKey], rows);
};

export const selectedTasksMeetComparativeRules = (
  selectedKeys: string[],
  rows: any[],
  {pdfBulkExportSamePedido = false}: {pdfBulkExportSamePedido?: boolean} = {},
) => {
  if (!selectedKeys?.length) return false;
  if (!selectedTasksShareTituloTarea(selectedKeys, rows)) return false;

  let mismoPedido = '';
  return selectedKeys.every((key) => {
    const task = findTaskInRows(rows, key);
    if (!task || !['Cerrada', 'PendienteRevision'].includes(task?.estado)) return false;

    if (pdfBulkExportSamePedido) {
      const pedido = task.listaProcedimiento?.find((p) => p.pregunta?.label === 'PEDIDO');
      if (pedido) {
        const pedidoText = pedido.textField?.trim() || '';
        if (mismoPedido === '') {
          mismoPedido = pedidoText;
          return true;
        }
        return pedidoText === mismoPedido;
      }
    }
    return true;
  });
};

export const selectedTasksMeetZipRules = (selectedKeys: string[], rows: any[]) => {
  if (!selectedKeys?.length) return false;
  return selectedKeys.every((key) => {
    const task = findTaskInRows(rows, key);
    return ['Cerrada', 'PendienteRevision'].includes(task?.estado);
  });
};
